import { useState } from "react";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { StatsSection } from "@/components/landing/StatsSection";
import { Marquee } from "@/components/landing/Marquee";
import { Credentials } from "@/components/landing/Credentials";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { CreditCalculator } from "@/components/landing/CreditCalculator";
import { Pricing } from "@/components/landing/Pricing";
import { Faq } from "@/components/landing/Faq";
import { Footer } from "@/components/landing/Footer";
import { CheckoutModal } from "@/components/landing/CheckoutModal";

export default function Landing() {
  const [selectedPkg, setSelectedPkg] = useState(null);

  return (
    <div data-testid="landing-page">
      <Navbar />
      <Hero />
      <StatsSection />
      <Marquee />
      <Credentials />
      <HowItWorks />
      <CreditCalculator onSelect={setSelectedPkg} />
      <Pricing onSelect={setSelectedPkg} />
      <Faq />
      <Footer />
      <CheckoutModal pkg={selectedPkg} onClose={() => setSelectedPkg(null)} />
    </div>
  );
}
